import React, {Component} from 'react';
import Styles from './style.css';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import {BeatLoader} from "react-spinners";
import {langRegister} from "../../services/langRegister";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {cartRegister} from "../../services/cartRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {imagesRegister} from "../../services/imagesRegister";
import ErrorHandler from "../error-handler/component";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import {tokenRegister} from "../../services/tokenRegister";
import {userRegister} from "../../services/userRegister";
import BoosterHome from "../../pages/booster-home/component";
import BoosterCrossRoad from "../../pages/booster-crossroad/component";
import BoosterIndustry from "../../pages/booster-industry/component";
import BoosterImage from "../../pages/booster-images/component";
import BoosterSlogans from "../../pages/booster-slogans/component";
import BoosterAds from "../../pages/booster-ads/component";
import BoosterFilter from "../../pages/booster-filter/component";
import BoosterBudget from "../../pages/booster-budget/component";
import BoosterCheckout from "../../pages/booster-checkout/component";
import BoosterLogin from "../../pages/booster-login/component";
import BoosterUser from "../../pages/booster-user/component";
import BoosterForgotPassword from "../../pages/booster-forgot-password/component";
import BoosterRegister from "../../pages/booster-register/component";
import BoosterLoginToken from "../../pages/booster-login-token/component";
import BoosterRedirect from "../../pages/booster-redirect/signup-payment-redirect";
import BoosterResetPassword from "../../pages/booster-reset-password/component";
import BoosterPayment from "../../pages/booster-payment/component";
import BoosterConfirmation from "../../pages/booster-confirmation/component";
import BoosterAbout from "../../pages/booster-about/component";
import BoosterReseller from "../../pages/booster-reseller/component";
import BoosterOptions from "../../pages/booster-options/component";
import BoosterSlogansDivided from "../../pages/booster-slogans-divided/component";
import withAuth from "../../functions/withAuth";

import {Redirect} from 'react-router-dom';
import BoosterIndustryPropertyBooster from "../../pages/booster-industry-pages/propertybooster/component";
import BoosterTheme from "../../pages/booster-theme/component";
import BoosterThemeCustom from "../../pages/booster-theme-custom/component";
import BoosterIndustryBoostaBostad from "../../pages/booster-industry-pages/boostabostad/component";
import BoosterVideo from "../../pages/booster-video/component";
import BoosterSlideshow from "../../pages/booster-slideshow/component";
import BoosterIndustryYieldlock from "../../pages/booster-industry-pages/yieldlock/component";
import BoosterYieldlock from "../../pages/booster-yieldlock/component";
import YieldlockPdf from "../../pages/yieldlock-pdf/component";
import BoosterPdf from "../../pages/booster-pdf/component";

import PBfaviconAppleTouch from '../../assets/propertybooster-favicon/apple-touch-icon.png';
import PBfavicon16 from '../../assets/propertybooster-favicon/favicon-16x16.png';
import PBfavicon32 from '../../assets/propertybooster-favicon/favicon-32x32.png';
import PBfaviconSiteManifest from '../../assets/propertybooster-favicon/site.webmanifest';
import PBfaviconSiteSafari from '../../assets/propertybooster-favicon/safari-pinned-tab.svg';

import BBfaviconAppleTouch from '../../assets/boostabostad-favicon/apple-touch-icon.png';
import BBfavicon16 from '../../assets/boostabostad-favicon/favicon-16x16.png';
import BBfavicon32 from '../../assets/boostabostad-favicon/favicon-32x32.png';
import BBfaviconSiteManifest from '../../assets/boostabostad-favicon/site.webmanifest';
import BBfaviconSiteSafari from '../../assets/boostabostad-favicon/safari-pinned-tab.svg';

import YLfaviconAppleTouch from '../../assets/yieldlock-favicon/apple-touch-icon.png';
import YLfavicon16 from '../../assets/yieldlock-favicon/favicon-16x16.png';
import YLfavicon32 from '../../assets/yieldlock-favicon/favicon-32x32.png';
import YLfaviconSiteManifest from '../../assets/yieldlock-favicon/site.webmanifest';
import YLfaviconSiteSafari from '../../assets/yieldlock-favicon/safari-pinned-tab.svg';

import {Helmet} from 'react-helmet'
import BoosterAgents from "../../pages/booster-agents/component";
import {agentRegister} from "../../services/agentRegister";

class RouterWrapper extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            market: null,
            lang: null,
            no_follow: false
        }
    };

    componentWillMount() {
        this.functions.setApiDomain();
    }

    componentWillReceiveProps() {
        this.functions.setApiDomain();
    }

    update = {
        data: (response) => {

            //TEMP
            //response.languages = ["en", "sv"];

            salesChannelRegister.set("name", response.type);

            salesChannelRegister.set("saleschannel_name", response.name);

            if (this.props.match.params.market) {
                salesChannelRegister.set("market", this.props.match.params.market);
            }
            if (response.available_channel) {
                salesChannelRegister.set('available_channels', JSON.stringify(response.available_channel));
            } else {
                salesChannelRegister.set('available_channels', JSON.stringify({
                    fb: true,
                    google: true,
                    bing: true,
                    instagram: true
                }));
            }
            if (response.name) {
                salesChannelRegister.set("company_name", response.name);
                this.update.title(response.name);
            }
            if (response.stripe_public_key) {
                salesChannelRegister.set("stripe_public_key", response.stripe_public_key);
            }
            if (response.logo) {
                salesChannelRegister.set('logo', response.logo);
            }
            if (response.goal_off) {
                salesChannelRegister.set('goal_off', response.goal_off);
            }
            if (response.social_targeting) {
                salesChannelRegister.set('social_targeting', response.social_targeting);
            }
            if (response.private) {
                salesChannelRegister.set('private', response.private);
            }
            if (response.logo_dashboard) {
                salesChannelRegister.set('logo_dashboard', response.logo_dashboard);
            }
            if (response.logo_mobile) {
                salesChannelRegister.set('logo_mobile', response.logo_mobile);
            }
            if (response.keyword_languages) {
                salesChannelRegister.set('keyword_languages', JSON.stringify(response.keyword_languages));
            }
            if (response.country_region) {
                salesChannelRegister.set('country_region', JSON.stringify(response.country_region));
            }

            /*TEMPORARY REMOVE LATER*/
            salesChannelRegister.set('country_regions_count', 12);
            /*TEMPORARY REMOVE LATER*/

            if (response.default_language) {
                salesChannelRegister.set('default_language', response.default_language);
            }
            if (response.channels) {
                salesChannelRegister.set('channels', JSON.stringify(response.channels));
            }
            if (response.currency) {
                salesChannelRegister.set('currency', response.currency.toLowerCase());
            }
            if (response.from_email) {
                salesChannelRegister.set('email', response.from_email);
            }
            if (response.campaign_duration) {
                try {
                    let sorted = response.campaign_duration.sort(function (a, b) {
                        return b - a
                    });
                    salesChannelRegister.set('durations', JSON.stringify(sorted));
                } catch (e) {
                    salesChannelRegister.set('durations', JSON.stringify(response.campaign_duration));
                }
            }
            if (response.default_campaign_duration) {
                salesChannelRegister.set('default_duration', response.default_campaign_duration);
            }
            if (response.ga_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                ReactGA.initialize(response.ga_id);
                salesChannelRegister.set('ga_id', response.ga_id);
            }
            if (response.ga4_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                ReactGA4.initialize(response.ga4_id);
                salesChannelRegister.set('ga4_id', response.ga4_id);
            }
            if (response.fb_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                ReactPixel.init(response.fb_id);
                salesChannelRegister.set('fb_id', response.fb_id);
            }
            if (response.vat) {
                salesChannelRegister.set('vat', response.vat);
            } else {
                salesChannelRegister.set('vat', 0);
            }
            /*
            if (response.socialData) {
                if (response.socialData.image && response.socialData.title !== "") {
                    salesChannelRegister.set('socialIcon', response.socialData.image);
                }
                if (response.socialData.title && response.socialData.title !== "") {
                    salesChannelRegister.set('socialTitle', response.socialData.title);
                }
                if (response.socialData.facebookID && response.socialData.facebookID !== "") {
                    salesChannelRegister.set('facebookId', response.socialData.facebookID);
                }
                if (response.socialData.instagramID && response.socialData.instagramID !== "") {
                    salesChannelRegister.set('instagramId', response.socialData.instagramID);
                }
            }
            */
            //TEMP -> REMOVE LATER
            if (this.props.match.params.market === "se") {
                salesChannelRegister.set('ad_languages', JSON.stringify([{
                    value: "sv",
                    title: {en: "Swedish", sv: "Svenska"}
                }]));
                salesChannelRegister.set('default_ad_language', "sv");
            } else if (this.props.match.params.market === "ae") {
                salesChannelRegister.set('ad_languages', JSON.stringify([{value: "en", title: {en: "English"}}]));
                salesChannelRegister.set('default_ad_language', "en");
            }
            //TEMP -> REMOVE LATER
            if (this.props.match.params.market === "se") {
                salesChannelRegister.set('languages', JSON.stringify([{
                    code: "sv",
                    name: "Svenska",
                    names: {sv: "Svenska", en: "Svenska"}
                }, {code: "en", name: "Engelska", names: {sv: "English", en: "English"}}]));
            } else if (this.props.match.params.market === "ae") {
                salesChannelRegister.set('languages', JSON.stringify([{
                    code: "en",
                    name: "English",
                    names: {en: "English"}
                }]));
            }

            try {
                for (let i = 0; i < response.languages.length; i++) {
                    if (this.props.match.params.lang.toLowerCase() === response.languages[i].toLowerCase()) {
                        langRegister.set(response.languages[i].toLowerCase());
                        break;
                    }
                }
            } catch (e) {
                langRegister.set(response.default_language.toLowerCase());
            }

            this.setState({error: false, isLoading: false});
        },
        title: (name) => {
            //document.title = name + " | " + this.renders.text("item_1");
        }
    };

    functions = {
        checkIfPrivate: () => {
            //this.setState({error: false, isLoading: false});
        },
        getHostingUrl: (url) => {
            var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
            if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
                return match[2];
            } else {
                return null;
            }
        },
        setDomain: (url) => {
            if (url.indexOf('localhost') !== -1) {

                this.functions.setVariables();

                //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! SET LOCALHOST VALUE HERE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                this.functions.setTheme('propertybooster');
                //this.functions.setTheme('boostabostad');
                //this.functions.setTheme('yieldlock');
                //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! SET LOCALHOST VALUE HERE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

            } else {
                let new_url = this.functions.getHostingUrl(url);
                let subdomain = new_url.split('.')[0];
                let domain = new_url.split('.')[1];
                let domain_ending = new_url.split('.')[2];
                dataRegister.setDomain(domain + '.' + domain_ending);
                this.functions.setVariables(domain);
                this.functions.setTheme(domain);
            }
        },
        setTheme: (id) => {

            if (id === 'devpropertybooster' || id === 'propertybooster') {

                document.documentElement.style.setProperty('--first-color', '#33b8cf');
                document.documentElement.style.setProperty('--second-color', '#99dbe7');
                document.documentElement.style.setProperty('--third-color', '#d6f1f5');
                document.documentElement.style.setProperty('--fourth-color', '#1a6b85');
                document.documentElement.style.setProperty('--fifth-color', '#000000');
                document.documentElement.style.setProperty('--sixth-color', '#bfbfbf');
                document.documentElement.style.setProperty('--seventh-color', '#242424');
                document.documentElement.style.setProperty('--eigthth-color', '#4d4d4d');
                document.documentElement.style.setProperty('--ninth-color', '#6e6e6e');
                document.documentElement.style.setProperty('--black-base-color', '#000000');

                //6e6e6e

            } else if (id === 'devboostabostad' || id === 'boostabostad') {

                document.documentElement.style.setProperty('--first-color', '#7ECF5B');
                document.documentElement.style.setProperty('--second-color', '#AEEC93');
                document.documentElement.style.setProperty('--third-color', '#E5F5DE');
                document.documentElement.style.setProperty('--fourth-color', '#548A3C');
                document.documentElement.style.setProperty('--fifth-color', '#000000');
                document.documentElement.style.setProperty('--sixth-color', '#bfbfbf');
                document.documentElement.style.setProperty('--seventh-color', '#242424');
                document.documentElement.style.setProperty('--eigthth-color', '#4d4d4d');
                document.documentElement.style.setProperty('--ninth-color', '#6e6e6e');
                document.documentElement.style.setProperty('--black-base-color', '#000000');


            } else if (id === 'devyieldlock' || id === 'yieldlock') {

                document.documentElement.style.setProperty('--first-color', '#00273A');
                document.documentElement.style.setProperty('--second-color', '#F7F9F9');
                document.documentElement.style.setProperty('--third-color', '#F8F9F9');
                document.documentElement.style.setProperty('--fourth-color', '#00273A');
                document.documentElement.style.setProperty('--fifth-color', '#00273A');
                document.documentElement.style.setProperty('--sixth-color', '#80929C');
                document.documentElement.style.setProperty('--seventh-color', '#335262');
                document.documentElement.style.setProperty('--eigthth-color', '#1A3C4E');
                document.documentElement.style.setProperty('--ninth-color', '#80929C');
                document.documentElement.style.setProperty('--black-base-color', '#00273A');

            } else {

                //PROPERTYBOOSTER

                document.documentElement.style.setProperty('--first-color', '#33b8cf');
                document.documentElement.style.setProperty('--second-color', '#000000');
                document.documentElement.style.setProperty('--third-color', '#d6f1f5');
                document.documentElement.style.setProperty('--fourth-color', '#1a6b85');
                document.documentElement.style.setProperty('--fifth-color', '#000000');
                document.documentElement.style.setProperty('--sixth-color', '#bfbfbf');
                document.documentElement.style.setProperty('--seventh-color', '#242424');
                document.documentElement.style.setProperty('--eigthth-color', '#4d4d4d');
                document.documentElement.style.setProperty('--ninth-color', '#6e6e6e');
                document.documentElement.style.setProperty('--black-base-color', '#000000');

            }
        },
        setApiDomain: () => {
            try {
                if (window.location.href.toLowerCase().indexOf('dev') !== -1) {
                    this.setState({no_follow: true});
                }
            } catch (e) {
                console.log(e);
            }
            try {
                dataRegister.documentLocation().then((response) => {
                    let environment = response.headers.get('APP_PRODUCTION');
                    if (environment === "true") {
                        dataRegister.setApiDomain("primehit");
                        this.functions.setDomain(window.location.href);
                    } else if (environment === "local") {
                        dataRegister.setApiDomain(this.functions.getHostingUrl(window.location.href));
                        this.functions.setDomain(window.location.href);
                    } else {
                        dataRegister.setApiDomain("devprimehit");
                        this.functions.setDomain(window.location.href);
                    }
                }, (error) => {
                    dataRegister.setApiDomain("devprimehit");
                    this.functions.setDomain(window.location.href);
                });
            } catch (e) {
            }
        },
        setVariables: () => {
            if (salesChannelRegister.get('market') !== this.props.match.params.market) {

                cartRegister.remove();
                quotesRegister.remove();
                imagesRegister.remove();
                tokenRegister.remove();
                userRegister.remove();
                agentRegister.remove();
                salesChannelRegister.remove('socialIcon');
                salesChannelRegister.remove('socialTitle');
                salesChannelRegister.remove('facebookId');
                salesChannelRegister.remove('instagramId');
                salesChannelRegister.remove('private');

                let channel = "";

                if (window.location.hostname.indexOf("propertybooster") !== -1) {
                    channel = "propertybooster";
                } else if (window.location.hostname.indexOf("boostabostad") !== -1) {
                    channel = "boostabostad";
                } else if (window.location.hostname.indexOf("yieldlock") !== -1) {
                    channel = "yieldlock";
                } else if (window.location.hostname.indexOf("localhost") !== -1) {

                    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! SET LOCALHOST VALUE HERE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                    channel = "propertybooster";
                    //channel = "boostabostad";
                    //channel = "yieldlock";
                    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! SET LOCALHOST VALUE HERE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

                }

                dataRegister.getSalesChannelData(this.props.match.params.market, channel).then((response) => {
                    this.update.data(response);
                }, (error) => {
                    this.setState({error: true, isLoading: false});
                });
            } else {

                let channel = "";

                if (window.location.hostname.indexOf("propertybooster") !== -1) {
                    channel = "propertybooster";
                } else if (window.location.hostname.indexOf("boostabostad") !== -1) {
                    channel = "boostabostad";
                } else if (window.location.hostname.indexOf("yieldlock") !== -1) {
                    channel = "yieldlock";
                } else if (window.location.hostname.indexOf("localhost") !== -1) {

                    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! SET LOCALHOST VALUE HERE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                    channel = "propertybooster";
                    //channel = "boostabostad";
                    //channel = "yieldlock";
                    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! SET LOCALHOST VALUE HERE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

                }

                dataRegister.getSalesChannelData(this.props.match.params.market, channel).then((response) => {
                    this.update.data(response);
                }, (error) => {
                    this.setState({error: true, isLoading: false});
                });
            }
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("router-wrapper", item);
        }
    };

    render() {
        return (
            <div>
                {
                    window.location.href.indexOf("propertybooster") !== -1 &&
                    <Helmet>
                        <title>Property Booster | Property listings on steroids</title>
                        <meta name="description" content="We are on a mission to boost property listings with leading adtech, simply launch agency grade campaigns in minutes and enjoy close to zero admin – pay only for performance. Leverage AI driven multi-channel advertising across Google, Facebook, Instagram, Bing and many more"/>
                        <link rel="apple-touch-icon" sizes="180x180" href={PBfaviconAppleTouch}/>
                        <link rel="icon" type="image/png" sizes="32x32" href={PBfavicon32}/>
                        <link rel="icon" type="image/png" sizes="16x16" href={PBfavicon16}/>
                        <link rel="manifest" href={PBfaviconSiteManifest}/>
                        <link rel="mask-icon" href={PBfaviconSiteSafari} color="#000000"/>
                        <meta name="msapplication-TileColor" content="#33b8cf"/>
                        <meta name="theme-color" content="#ffffff"/>
                    </Helmet>
                }
                {
                    window.location.href.indexOf("boostabostad") !== -1 &&
                    <Helmet>
                        <title>Boosta Bostad | Bostadsobjekt på steroider</title>
                        <meta name="description" content="Vi är på kurs med att boosta bostadsobjekt med ledande adtech, skapa byråkampanjer på nolltid och slipp allt bök – betala bara för resultat. Få hävstång med AI-optimerad flerkanals-annonsering på Google, Facebook, Instagram, Bing och många fler"/>
                        <link rel="apple-touch-icon" sizes="180x180" href={BBfaviconAppleTouch}/>
                        <link rel="icon" type="image/png" sizes="32x32" href={BBfavicon32}/>
                        <link rel="icon" type="image/png" sizes="16x16" href={BBfavicon16}/>
                        <link rel="manifest" href={BBfaviconSiteManifest}/>
                        <link rel="mask-icon" href={BBfaviconSiteSafari} color="#000000"/>
                        <meta name="msapplication-TileColor" content="#7ecf5b"/>
                        <meta name="theme-color" content="#ffffff"/>
                    </Helmet>
                }
                {
                    window.location.href.indexOf("yieldlock") !== -1 &&
                    <Helmet>
                        <title>YIELDLOCK | Yieldlock any property</title>
                        <meta name="description" content="Yieldlock any on-plan property and boost attraction and resale value with the world's leading retail leaseback framework powered by ROISEC. Leverage powerful lead generation and produce intent for millions of investors worldwide without any administration or prior skills"/>
                        <link rel="apple-touch-icon" sizes="180x180" href={YLfaviconAppleTouch}/>
                        <link rel="icon" type="image/png" sizes="32x32" href={YLfavicon32}/>
                        <link rel="icon" type="image/png" sizes="16x16" href={YLfavicon16}/>
                        <link rel="manifest" href={YLfaviconSiteManifest}/>
                        <link rel="mask-icon" href={YLfaviconSiteSafari} color="#000000"/>
                        <meta name="msapplication-TileColor" content="#e65032"/>
                        <meta name="theme-color" content="#ffffff"/>
                    </Helmet>
                }
                {
                    !this.state.isLoading && !this.state.error &&
                    <Switch>

                        <Route exact path={this.props.match.url} component={BoosterHome}/>
                        <Route exact path={this.props.match.url + '/booster/home'} component={BoosterHome}/>
                        <Route exact path={this.props.match.url + '/about'} component={BoosterAbout}/>
                        <Route exact path={this.props.match.url + '/reseller'} component={BoosterReseller}/>

                        <Route exact path={this.props.match.url + '/token/:hash'} component={BoosterLoginToken}/>
                        <Route exact path={this.props.match.url + '/forgot-password'}
                               component={BoosterForgotPassword}/>
                        <Route exact path={this.props.match.url + '/forgot-password/:email'}
                               component={BoosterForgotPassword}/>
                        <Route exact path={this.props.match.url + '/register'} component={BoosterRegister}/>
                        <Route exact path={this.props.match.url + '/login'} component={BoosterLogin}/>
                        <Route exact path={this.props.match.url + '/changepassword/:code'}
                               component={BoosterResetPassword}/>
                        <Route exact path={this.props.match.url + '/redirect'} component={BoosterRedirect}/>

                        <Route exact path={this.props.match.url + '/booster/agents'} component={BoosterAgents}/>
                        <Route exact path={this.props.match.url + '/booster/options'} component={BoosterOptions}/>
                        <Route exact path={this.props.match.url + '/booster/crossroad'} component={BoosterCrossRoad}/>

                        {
                            salesChannelRegister.get('name') === 'propertybooster' &&
                            <Route exact path={this.props.match.url + '/booster/industry'}
                                   component={BoosterIndustryPropertyBooster}/>
                        }
                        {
                            salesChannelRegister.get('name') === 'boostabostad' &&
                            <Route exact path={this.props.match.url + '/booster/industry'}
                                   component={BoosterIndustryBoostaBostad}/>
                        }
                        {
                            salesChannelRegister.get('name') === 'yieldlock' &&
                            <Route exact path={this.props.match.url + '/booster/industry'}
                                   component={BoosterIndustryYieldlock}/>
                        }

                        <Route exact path={this.props.match.url + '/pdf/booster'} component={BoosterPdf}/>

                        <Route exact path={this.props.match.url + '/pdf/yieldlock'} component={YieldlockPdf}/>

                        <Route exact path={this.props.match.url + '/booster/calculator'} component={BoosterYieldlock}/>

                        <Route exact path={this.props.match.url + '/booster/slogans-custom'}
                               component={BoosterSlogans}/>
                        <Route exact path={this.props.match.url + '/booster/slogans'}
                               component={BoosterSlogansDivided}/>
                        <Route exact path={this.props.match.url + '/booster/ads'} component={BoosterAds}/>
                        <Route exact path={this.props.match.url + '/booster/filter'} component={BoosterFilter}/>
                        <Route exact path={this.props.match.url + '/booster/budget'} component={BoosterBudget}/>
                        <Route exact path={this.props.match.url + '/booster/checkout'} component={BoosterCheckout}/>
                        <Route exact path={this.props.match.url + '/booster/payment'} component={BoosterPayment}/>
                        <Route exact path={this.props.match.url + '/booster/confirmation'}
                               component={BoosterConfirmation}/>
                        <Route exact path={this.props.match.url + '/booster/images'} component={BoosterImage}/>
                        <Route exact path={this.props.match.url + '/booster/video'} component={BoosterVideo}/>
                        <Route exact path={this.props.match.url + '/booster/slideshow'} component={BoosterSlideshow}/>
                        <Route exact path={this.props.match.url + '/booster/theme'} component={BoosterTheme}/>
                        <Route exact path={this.props.match.url + '/booster/theme-custom'}
                               component={BoosterThemeCustom}/>

                        <Route path={this.props.match.url + '/user'} component={BoosterUser}/>

                        {
                            salesChannelRegister.get('name') === 'boostabostad' &&
                            <Redirect to={"/se/sv"}/>
                        }
                        {
                            salesChannelRegister.get('name') === 'propertybooster' &&
                            <Redirect to={"/ae/en"}/>
                        }
                        {
                            salesChannelRegister.get('name') === 'yieldlock' &&
                            <Redirect to={"/ae/en"}/>
                        }

                    </Switch>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler/>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
            </div>
        );
    }

}

export default RouterWrapper


// WEBPACK FOOTER //
// ./src/components/router-wrapper/component.js